module.exports = __webpack_public_path__ + "img/undraw_voting_nvu7 - Copy.e11abcc6.png";